import { ConfigProvider, theme } from 'antd'
import enUS from 'antd/locale/en_US'
import { mainBlue } from '~app/helper/Colors'
import { useThemeMode } from './ThemeModeProvider'

const DesignContainer = ({ children }: React.PropsWithChildren<unknown>) => {
  const { effectiveMode } = useThemeMode()

  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        algorithm:
          effectiveMode === 'dark'
            ? [theme.compactAlgorithm, theme.darkAlgorithm]
            : theme.compactAlgorithm,
        token: {
          colorPrimary: mainBlue,
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default DesignContainer
